.alerts {
  display: flex;
  z-index: 999999;
  position: fixed;
  top: 1rem;
  left: 0;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 0;
  padding: 0 1.25rem;
  overflow: visible;

  @media (min-width: 400px) {
    top: 2rem;
  }

  .alert {
    margin: 1rem auto 0;
  }
}
